module.exports = __webpack_public_path__ + "img/12加入我们-img5.0b52b21e.jpg";